export default __webpack_public_path__ + "static/media/supply_1.e569938f.png";